export const EMPTY_FIELD = 'Это поле не может быть пустым'
export const PHONE_NOT_VALID = 'Неверный номер'
